import React, { useState } from "react";
import "./index.css";
import BackgroundDiv from "../../components/BackgroundDiv";
import FirstImg from "../../assets/first-img.png";
import AboutUs from "../../assets/about-us.png";
import OurFocus from "../../assets/our-focus.png";
import OurTheme from "../../assets/our-theme.png";
import PastHighlightsImg from "../../assets/past-highlights.png";
import OurObject from "../../assets/our-objective.png";
import TestimonialsImg from "../../assets/testimonials.png";
import ContactUs from "../../assets/contact-us.png";
import Header from "../../components/Header";
import RightSwiper from "../../components/RightSwiper";
import TripleSwiper from "../../components/TripleSwiper";
import HorizontalGroupSwiper from "../../components/HorizontalGroupSwiper";
import PastHighlights from "../../components/PastHighlights";
import Testimonials from "../../components/Testimonials";
import CryptoJS from 'crypto-js';
const ENCRYPTION_KEY = 'c03425183845998290609d540d3d17b5e368789117f4e396bbfedafaa9d667f5'
const IV_LENGTH = 16; // 128位IV
function encrypt(text) {
  const iv = CryptoJS.lib.WordArray.random(IV_LENGTH);
  const cipher = CryptoJS.AES.encrypt(
    text,
    CryptoJS.enc.Hex.parse(ENCRYPTION_KEY),
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );
  return iv.toString(CryptoJS.enc.Hex) + ':' + cipher.ciphertext.toString(CryptoJS.enc.Hex);
}
export default function Home() {
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('success');

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: ''
  });
  const sendEmail = (e) => {
    e.preventDefault();
    fetch('https://www.summerinternational.uk/summer-international-node/send-email', {
    // fetch('http://localhost:3000/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({name:encrypt(formData.name),email:encrypt(formData.email),phone:encrypt(formData.phone)})
    }).then(async (res) => {
      const data = await res.json();

      if (!res.ok) {
        setMessageType('error');
        setMessage(data.message || 'Submission failed');
        throw new Error(data.message || '请求失败');
      }

      setFormData({ name: '', email: '', phone: '' });
      setMessageType('success');
      setMessage('Submission successful! We will contact you soon');

      setTimeout(() => setMessage(''), 3000);
    })
      .catch((error) => {
        setMessageType('error');
        setMessage(error.message);
        setTimeout(() => setMessage(''), 3000);
      });
  };
  return (
    <div className="app">
      {message && (
        <div className={`message-bubble ${messageType}`}>
          {message}
        </div>
      )}
      <Header />
      <div className="main-wrapper">
        <BackgroundDiv
          backgroundImg={FirstImg}
          width={1440}
          height={630}
        ></BackgroundDiv>
        <BackgroundDiv
          id="background-about"
          backgroundImg={AboutUs}
          width={1440}
          height={1051}
        ></BackgroundDiv>
        <BackgroundDiv
          id="background-focus"
          backgroundImg={OurFocus}
          width={1440}
          height={1958}
        >
          <RightSwiper />
          <TripleSwiper />
        </BackgroundDiv>
        <BackgroundDiv
          id="background-theme"
          backgroundImg={OurTheme}
          width={1440}
          height={835}
        >
          <HorizontalGroupSwiper />
        </BackgroundDiv>
        <BackgroundDiv
          id="background-past-highlights"
          backgroundImg={PastHighlightsImg}
          width={1440}
          height={838}
        >
          <PastHighlights />
        </BackgroundDiv>
        <BackgroundDiv
          id="background-objective"
          backgroundImg={OurObject}
          width={1440}
          height={600}
        ></BackgroundDiv>
        <BackgroundDiv
          id="background-testimonials"
          backgroundImg={TestimonialsImg}
          width={1440}
          height={750}
        >
          <Testimonials />
        </BackgroundDiv>
        <BackgroundDiv
          id="background-contact"
          backgroundImg={ContactUs}
          width={1440}
          height={626}
        >
          <form onSubmit={sendEmail}>
            <div className="flex-box padding-281">
              <input
                className="input-small"
                placeholder="Name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
              />
              <input
                className="input-small"
                placeholder="Email"
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
              />
            </div>
            <div className="flex-box">
              <input
                className="input-large"
                placeholder="Telephone Number"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                required
              />
            </div>
            <div className="flex-box">
              <button type="submit" className="submit-btn">Submit</button>
            </div>
          </form>
        </BackgroundDiv>
      </div>
    </div>
  );
}
